import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Table } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
// import CalendarRangeComponent from "../../components/CalendarRange/CalendarRangeComponent";
import CalendarComponent from "../../components/Calendar/CalendarComponent";
import * as Actions from "../../store/action/inspectionMission";
import { useDispatch, useSelector } from "react-redux";
import { fetchRepairers } from "../../store/action/repairer";
import { format } from "date-fns";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { Box, Grid } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh" 
  },
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  tableCellSmallCollapseHead: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(74, 75, 104, 1)",
  },
  tableCellSmallCollapse: {
    fontFamily: "Poppins",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  dialogPaper: {
    width: "1300px",
    overflow: "hidden",
    background: "rgb(243, 246, 249)",
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },

  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  closeButton: {
    cursor: "pointer",
    color: "rgba(32, 18, 70, 1)",
    marginLeft: 1051,
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: "13.8px",
    fontWeight: 600,
    lineHeight: "20.7px",
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    marginLeft: "10px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },

  optionLabel: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  annulerStyle: {
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(255, 229, 229, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    color: "rgba(255, 54, 54, 1)",
    border: 0,
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "#464E5F",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(187, 200, 8, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  titreLabelDialog: {
    marginLeft: "20px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: "#464E5F",
    padding: "10px 0px ",
  },
  selectInputDialog: {
    marginLeft: "20px",
    border: "1px solid #DEDEDE",
    background: "rgba(255, 255, 255, 1)",
    width: "90%",
    height: "36px",
    borderRadius: 5,
    fontFamily: "Poppins",
    fontSize: "12px",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "180px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  optionItem: {
    width: '150px',
    padding: theme.spacing(1),
    cursor: 'pointer',
    backgroundColor: 'white',
    color: 'rgba(32, 18, 70, 1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
    fontWeight: 400,
    textAlign: 'left',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  }, 
}));
export default function Expertises() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { inspectorData } = useSelector((state) => state.inspectorReducer);
  const { repairers } = useSelector((state) => state.repairers);
  const { missions } = useSelector((state) => state.inspectionReducer);

  const [expertFilter, setExpertFilter] = useState("");
  const [garageFilter, setGarageFilter] = useState("");
  const [dateFilterValue, setDateFilterValue] = useState(
    format(new Date(), "dd/MM/yyyy")
  );
  const [groupBy, setGroupBy] = useState("Garage");

  const fetchAllData = async (startDate, endDate) => {
    try {
      await dispatch(Actions.getAllInspector());
      await dispatch(fetchRepairers());
      await dispatch(
        Actions.filterInspectionMissions({
          filters: {
            missionDate: [
              startDate || new Date().toISOString().split("T")[0],
              endDate || startDate || new Date().toISOString().split("T")[0],
            ],
          },
        })
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const setDateValue = (data) => {
    if (Array.isArray(data) && data.length === 2) {
      // Adjust both start and end dates for timezone
      const adjustedStartDate = new Date(
        data[0].getTime() + Math.abs(data[0].getTimezoneOffset() * 60000)
      );
      const adjustedEndDate = new Date(
        data[1].getTime() + Math.abs(data[1].getTimezoneOffset() * 60000)
      );

      // Format dates as needed
      const formattedStartDate = adjustedStartDate.toISOString().split("T")[0];
      const formattedEndDate = adjustedEndDate.toISOString().split("T")[0];

      // Set filter values for display (if needed)
      setDateFilterValue(
        `${adjustedStartDate.toLocaleDateString(
          "fr-FR"
        )} - ${adjustedEndDate.toLocaleDateString("fr-FR")}`
      );

      // Fetch data based on the range of dates
      fetchAllData(formattedStartDate, formattedEndDate);
    } else {
      // Handle single date case if needed
      const adjustedDate = new Date(
        data.getTime() + Math.abs(data.getTimezoneOffset() * 60000)
      );
      const formattedDate = adjustedDate.toISOString().split("T")[0];

      setDateFilterValue(adjustedDate.toLocaleDateString("fr-FR"));
      fetchAllData(formattedDate, formattedDate);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [dispatch]);

  const groupMissions = (missions, groupBy, garageFilter, expertFilter) => {
    const filteredMissions = missions.filter((mission) => {
      const garageName =
        mission.garageDetails?.organizationName || "Hors Garage";
      const expertName = `${mission.inspectorDetails?.name} ${mission.inspectorDetails?.lastName}`;
      const garageMatch = garageFilter === "" || garageName === garageFilter;
      const expertMatch = expertFilter === "" || expertName === expertFilter;

      return garageMatch && expertMatch;
    });

    return filteredMissions.reduce((groups, mission) => {
      const groupKey =
        groupBy === "Garage"
          ? mission.garageDetails?.organizationName || "Hors Garage"
          : `${mission.inspectorDetails?.name} ${mission.inspectorDetails?.lastName}`;
      if (!groups[groupKey]) {
        groups[groupKey] = [];
      }
      groups[groupKey].push(mission);
      return groups;
    }, {});
  };

  const groupedMissions = groupMissions(
    missions,
    groupBy,
    garageFilter,
    expertFilter
  );
  const horsGarageMissions = groupedMissions["Hors Garage"] || [];
  const otherMissions = Object.keys(groupedMissions).filter(
    (key) => key !== "Hors Garage"
  );

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "20px",
              marginBottom: "40px",
              whiteSpace: "nowrap",
            }}
          >
            <div className={classes.titre} style={{ width: "10%" }}>
              Filtrer par
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "45%",
                justifyContent: "flex-start",
              }}
            >
              <div className={classes.titreLabel}>
                Expert
                <select
                  className={classes.selectInput}
                  onChange={(e) => setExpertFilter(e.target.value)}
                >
                  <option className={classes.optionItem} value="">
                    Sélectionnez une option
                  </option>
                  {inspectorData?.map((inspector, index) => (
                    <option
                      className={classes.optionItem}
                      value={`${inspector?.personDetails?.name} ${inspector?.personDetails?.lastName}`}
                      key={index}
                    >
                      {inspector?.personDetails?.name}{" "}
                      {inspector?.personDetails?.lastName}
                    </option>
                  ))}
                </select>
              </div>
              <div className={classes.titreLabel}>
                Garage
                <select
                  className={classes.selectInput}
                  onChange={(e) => setGarageFilter(e.target.value)}
                >
                  <option className={classes.optionItem} value="">
                    Sélectionnez une option
                  </option>
                  <option className={classes.optionItem} value="Hors Garage">
                    Hors Garage
                  </option>
                  {repairers?.map((repairer, index) => (
                    <option
                      className={classes.optionItem}
                      value={repairer.organizationName}
                      key={index}
                    >
                      {repairer.organizationName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "45%",
                justifyContent: "flex-end",
              }}
            >
              <div className={classes.titre}>
                Grouper par
                <select
                  className={classes.selectInput}
                  onChange={(e) => setGroupBy(e.target.value)}
                  value={groupBy}
                >
                  <option className={classes.optionItem} value={"Garage"}>
                    Garage
                  </option>
                  <option className={classes.optionItem} value={"Expert"}>
                    Expert
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                alignItems: "center",
                width: "75%",
                paddingRight: "20px",
              }}
            >
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="small"
              >
                <thead>
                  <tr>
                    <TableCell
                      height={"43px"}
                      align="left"
                      className={classes.tableHeadRows}
                      style={{
                        borderTopLeftRadius: "6px",
                        borderBottomLeftRadius: "6px",
                      }}
                    >
                      {groupBy}
                    </TableCell>
                    <TableCell
                      height={"43px"}
                      align="right"
                      className={classes.tableHeadRows}
                      style={{
                        borderTopRightRadius: "6px",
                        borderBottomRightRadius: "6px",
                      }}
                    >
                      Planning
                    </TableCell>
                  </tr>
                </thead>
                <tbody>
                  {otherMissions.map((location) => (
                    <React.Fragment key={location}>
                      <tr>
                        <TableCell colSpan="2" style={{ border: 0 }}>
                          <Accordion allowMultiple>
                            <AccordionItem>
                              <AccordionButton
                                style={{
                                  height: "47px",
                                  border: "none",
                                  background: "rgba(255, 255, 255, 1)",
                                  borderBottom:
                                    "1px solid rgba(224, 224, 224, 1)",
                                }}
                              >
                                <AccordionIcon
                                  size="30px"
                                  style={{
                                    backgroundColor: "rgba(240, 243, 199, 1)",
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "5px",
                                    color: "rgba(187, 200, 8, 1)",
                                  }}
                                />
                                <Box
                                  as="div"
                                  textAlign="left"
                                  marginLeft="20px"
                                  style={{
                                    color: "#BBC808",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    lineHeight: "21px",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  {location}
                                </Box>
                              </AccordionButton>
                              <AccordionPanel
                                style={{
                                  background: "rgba(255, 255, 255, 1)",
                                  borderRadius: "11px",
                                }}
                              >
                                {groupedMissions[location].map((mission) => (
                                  <div
                                    key={mission._id}
                                    style={{
                                      padding: "10px 3px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      background: "rgba(249, 249, 249, 1)",
                                      borderBottom:
                                        "1px solid rgb(224, 224, 224)",
                                      color: "#464E5F",
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      lineHeight: "21px",
                                      fontFamily: "Poppins",
                                      alignItems: "center",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "15%",
                                        textAlign: "left",
                                      }}
                                    >
                                      {groupBy === "Garage"
                                        ? `${mission.inspectorDetails?.name} ${mission.inspectorDetails?.lastName}`
                                        : mission.garageDetails
                                            ?.organizationName || "Hors Garage"}
                                    </div>
                                    <div
                                      style={{
                                        width: "fit-content",
                                        height: "26px",
                                        borderRadius: "51px",
                                        background: "rgba(240, 243, 199, 1)",
                                        textAlign: "left",
                                        padding: "5px 7px 7px 7px",
                                        fontFamily: "Poppins",
                                        fontSize: "10.69px",
                                        fontWeight: 500,
                                        lineHeight: " 16.03px",
                                        color: "rgba(187, 200, 8, 1)",
                                      }}
                                    >
                                      {mission.relatedClaimUid || ""}
                                    </div>
                                    <div
                                      style={{
                                        width: "fit-content",
                                        height: "26px",
                                        textAlign: "left",
                                        padding: "5px 7px 7px 7px",
                                        fontFamily: "Poppins",
                                        fontSize: "10.69px",
                                        fontWeight: 500,
                                        lineHeight: " 16.03px",
                                        color: "rgba(187, 200, 8, 1)",
                                      }}
                                    >
                                      {mission.registrationCaracteristique
                                        ?.value || ""}
                                    </div>
                                    <div
                                      style={{
                                        width: "25%",
                                        textAlign: "right",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "inline-block",
                                          width: "80px",
                                          textAlign: "center",
                                          padding: "5px",
                                          borderRadius: "51px",
                                          border: 0,
                                          fontFamily: "Poppins",
                                          fontSize: "10.69px",
                                          fontWeight: 500,
                                          lineHeight: "16.03px",
                                          color:
                                            mission.status === "OPEN"
                                              ? "rgba(187, 200, 8, 1)"
                                              : mission.status === "DECLINED" ||
                                                mission.status === "CLOSED"
                                              ? "rgba(255, 54, 54, 1)"
                                              : mission.status === "ON_GOING"
                                              ? "rgba(187, 200, 8, 1)"
                                              : "rgba(0, 0, 0, 1)",
                                          backgroundColor:
                                            mission.status === "OPEN"
                                              ? "rgba(240, 243, 199, 1)"
                                              : mission.status === "DECLINED" ||
                                                mission.status === "CLOSED"
                                              ? "rgba(255, 229, 229, 1)"
                                              : mission.status === "ON_GOING"
                                              ? "rgba(240, 243, 199, 1)"
                                              : "rgba(240, 240, 240, 1)",
                                        }}
                                      >
                                        {mission.status}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        width: "25%",
                                        textAlign: "right",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "black",
                                          fontWeight: 400,
                                        }}
                                      >
                                        {new Date(mission.missionDate)
                                          .toLocaleDateString("fr-FR", {
                                            weekday: "long",
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                          })
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" ")}{" "}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </AccordionPanel>
                            </AccordionItem>
                          </Accordion>
                        </TableCell>
                      </tr>
                    </React.Fragment>
                  ))}
                  {horsGarageMissions.length > 0 && (
                    <React.Fragment>
                      <tr>
                        <TableCell colSpan="2" style={{ border: 0 }}>
                          <Accordion allowMultiple>
                            <AccordionItem>
                              <AccordionButton
                                style={{
                                  height: "47px",
                                  border: "none",
                                  background: "rgba(255, 255, 255, 1)",
                                  borderBottom:
                                    "1px solid rgba(224, 224, 224, 1)",
                                }}
                              >
                                <AccordionIcon
                                  size="30px"
                                  style={{
                                    backgroundColor: "rgba(240, 243, 199, 1)",
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "5px",
                                    color: "rgba(187, 200, 8, 1)",
                                  }}
                                />
                                <Box
                                  as="div"
                                  textAlign="left"
                                  marginLeft="20px"
                                  style={{
                                    color: "#BBC808",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    lineHeight: "21px",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  Hors Garage
                                </Box>
                              </AccordionButton>
                              <AccordionPanel
                                style={{ background: "rgba(249, 249, 249, 1)", borderRadius: "11px" }}>
                                {horsGarageMissions.map((mission) => (
                                  <div
                                    key={mission._id}
                                    style={{ padding: "10px 3px", display: 'flex', justifyContent: 'space-between', background: "rgba(249, 249, 249, 1)", borderBottom: '1px solid rgba(224, 224, 224, 1)', color: "#464E5F", fontSize: '12px', fontWeight: 400, lineHeight: '21px', fontFamily: 'Poppins' }}
                                  >
                                    <div
                                      style={{
                                        width: "15%",
                                        textAlign: "left",
                                      }}
                                    >
                                      {groupBy === "Garage"
                                        ? `${mission.inspectorDetails?.name} ${mission.inspectorDetails?.lastName}`
                                        : mission.garageDetails
                                            ?.organizationName || "Hors Garage"}
                                    </div>
                                    <div
                                      style={{
                                        width: "fit-content",
                                        height: "26px",
                                        borderRadius: "51px",
                                        background: "rgba(240, 243, 199, 1)",
                                        textAlign: "left",
                                        padding: "5px 7px 7px 7px",
                                        fontFamily: "Poppins",
                                        fontSize: "10.69px",
                                        fontWeight: 500,
                                        lineHeight: " 16.03px",
                                        color: "rgba(187, 200, 8, 1)",
                                      }}
                                    >
                                      {mission.relatedClaimUid || ""}
                                    </div>
                                    <div
                                      style={{
                                        width: "fit-content",
                                        height: "26px",

                                        textAlign: "left",
                                        padding: "5px 7px 7px 7px",
                                        fontFamily: "Poppins",
                                        fontSize: "10.69px",
                                        fontWeight: 500,
                                        lineHeight: " 16.03px",
                                        color: "rgba(187, 200, 8, 1)",
                                      }}
                                    >
                                      {mission.registrationCaracteristique
                                        ?.value || ""}
                                    </div>
                                    <div
                                      style={{
                                        width: "25%",
                                        textAlign: "right",
                                      }}
                                    >
                                     <div
                                        style={{
                                          display: "inline-block",
                                          width: "80px",
                                          textAlign: "center",
                                          padding: "5px",
                                          borderRadius: "51px",
                                          border: 0,
                                          fontFamily: "Poppins",
                                          fontSize: "10.69px",
                                          fontWeight: 500,
                                          lineHeight: "16.03px",
                                          color:
                                            mission.status === "OPEN"
                                              ? "rgba(187, 200, 8, 1)"
                                              : mission.status === "DECLINED" ||
                                                mission.status === "CLOSED"
                                              ? "rgba(255, 54, 54, 1)"
                                              : mission.status === "ON_GOING"
                                              ? "rgba(187, 200, 8, 1)"
                                              : "rgba(0, 0, 0, 1)",
                                          backgroundColor:
                                            mission.status === "OPEN"
                                              ? "rgba(240, 243, 199, 1)"
                                              : mission.status === "DECLINED" ||
                                                mission.status === "CLOSED"
                                              ? "rgba(255, 229, 229, 1)"
                                              : mission.status === "ON_GOING"
                                              ? "rgba(240, 243, 199, 1)"
                                              : "rgba(240, 240, 240, 1)",
                                        }}
                                      >
                                        {mission.status}
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        width: "25%",
                                        textAlign: "right",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontWeight: 400,
                                        }}
                                      >
                                        {new Date(mission.missionDate)
                                          .toLocaleDateString("fr-FR", {
                                            weekday: "long",
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                          })
                                          .split(" ")
                                          .map(
                                            (word) =>
                                              word.charAt(0).toUpperCase() +
                                              word.slice(1)
                                          )
                                          .join(" ")}{" "}
                                        
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </AccordionPanel>
                            </AccordionItem>
                          </Accordion>
                        </TableCell>
                      </tr>
                    </React.Fragment>
                  )}
                  {otherMissions.length === 0 && horsGarageMissions.length === 0 ?
                  <div style={{fontFamily : 'Poppins', fontWeight : 400 ,fontSize :15, lineHeight:'22.5px' ,color :'rgba(70, 78, 95, 1)' , padding : '20px' }}>
                  Aucune mission d'expertise planifiée pour la journée du {dateFilterValue}
                  </div>
                  :""}

                </tbody>
              </Table>
            </div>
            <div style={{ alignItems: "center", width: "20%" }}>
              <CalendarComponent setDateValue={setDateValue} />
            </div>
          </div>
        </div>
      </Paper>
    </div>
  );
}
